import NoAccessOverlay from './NoAccessOverlay';

export default NoAccessOverlay;
